export default __webpack_public_path__ + "static/media/virtual-bg13.112fa3ce.png";